import React from "react";
import Svg, { Path } from "react-native-svg";

interface BaseSquareLogoProps {
  size?: number;
  color?: string;
}

/**
 * Base logo square with exact design specifications:
 * - 5% radius with 60% smoothing for friendly, recognizable shape
 * - Vector-based for crisp rendering at any size
 */
const BaseSquareLogo = ({ size = 18, color = "white" }: BaseSquareLogoProps) => {
  // Calculate the rounded rectangle path with 5% radius and smoothing
  // For a square, 5% radius = size * 0.05
  const radius = size * 0.05;

  // 60% smoothing applied to the bezier curves
  // This creates the friendly, non-soft curve that Base requires
  const smoothing = 0.6;
  const smooth = radius * smoothing;

  return (
    <Svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <Path
        d={`
          M ${radius} 0
          L ${size - radius} 0
          C ${size - radius + smooth} 0, ${size} ${radius - smooth}, ${size} ${radius}
          L ${size} ${size - radius}
          C ${size} ${size - radius + smooth}, ${size - radius + smooth} ${size}, ${size - radius} ${size}
          L ${radius} ${size}
          C ${radius - smooth} ${size}, 0 ${size - radius + smooth}, 0 ${size - radius}
          L 0 ${radius}
          C 0 ${radius - smooth}, ${radius - smooth} 0, ${radius} 0
          Z
        `}
        fill={color}
      />
    </Svg>
  );
};

export default BaseSquareLogo;
